import { render } from "./SubjectSelection.vue?vue&type=template&id=074f3958&scoped=true"
import script from "./SubjectSelection.vue?vue&type=script&lang=js"
export * from "./SubjectSelection.vue?vue&type=script&lang=js"

import "./SubjectSelection.vue?vue&type=style&index=0&id=074f3958&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-074f3958"

export default script